import React, { useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import PluginContext from '../../../Product/context/plugin/pluginContext'
import AuthContext from '../../../Product/context/auth/authContext'
import { handleRedirectInternal } from '../../../Product/common/components'

// custom hook to load PayPal script safely
const usePaypalScript = (src) => {
    const [status, setStatus] = React.useState('idle')

    useEffect(() => {
        if (!src) return

        const savedDefine = window.define
        try {
            window.define = undefined
        } catch (e) {}

        const script = document.createElement('script')
        script.src = src
        script.async = true

        script.onload = () => {
            setStatus('ready')
            if (savedDefine) window.define = savedDefine
        }

        script.onerror = () => {
            setStatus('error')
            if (savedDefine) window.define = savedDefine
        }

        document.body.appendChild(script)

        return () => {
            if (savedDefine) window.define = savedDefine
            document.body.removeChild(script)
        }
    }, [src])

    return status
}

const Paypal = () => {
    const { paypalLogin, responseStatus } = useContext(PluginContext)
    const { user } = useContext(AuthContext)
    const { search } = useLocation()
    const history = useHistory()
    const query = new URLSearchParams(search)

    const script = usePaypalScript('https://www.paypalobjects.com/js/external/api.js')

    const getAccessToken = () => {
        paypalLogin({
            site_id: global?.storeDetails?.site_id,
            code: query.get('code'),
            user_id: user?.id,
        })
    }

    useEffect(() => {
        if (query.get('code') && user) {
            getAccessToken()
        }
    }, [query.get('code'), user])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.status === 'success' && responseStatus.from === 'paypalLogin') {
                window.close()
            }
            if (responseStatus.status === 'error' && responseStatus.from === 'paypalLogin') {
                handleRedirectInternal(history, 'dashboard/profile')
            }
        }
    }, [responseStatus, history])

    const paypalConnect = () =>
        window.paypal?.use(['login'], function (login) {
            login.render({
                appid: global.pluginConfiguration?.paypal_payout?.client_key,
                authend: process.env.REACT_APP_PAYMENTMODE,
                scopes: 'openid email https://uri.paypal.com/services/paypalattributes',
                containerid: 'paypal_btn',
                responseType: 'code',
                locale: 'en-us',
                buttonType: 'CWP',
                buttonShape: 'rectangle',
                buttonSize: 'lg',
                fullPage: 'true',
                returnurl: global.pluginConfiguration?.paypal_payout?.redirect_url,
            })
        })

    useEffect(() => {
        if (script === 'ready') {
            paypalConnect()
        }
    }, [script])

    return (
        <div>
            <span id="paypal_btn"></span>
        </div>
    )
}

export default Paypal
